
import * as persianTools from "@persian-tools/persian-tools"

const formattedPrices = (value) => {
    return new Intl.NumberFormat("fa-IR").format(value)
}

export const useParseDiscountDetails = () => {
    const parseDiscountDetails = (discountDetails) => {
        const discountObject = JSON.parse(discountDetails)

        let discountType = ""
        if (discountObject.type == "discount") {
            discountType = "عادی"
        } else if (discountObject.type == "incredible_offer") {
            discountType = "شگفت انگیز"
        }
        let html = ""
        html += "<strong>نوع:</strong> " + discountType + "<br />"
        html +=
            "<strong>مقدار:</strong> " +
            formattedPrices(discountObject.amount) +
            "<br />"
        html +=
            "<strong>درصد:</strong> " +
            persianTools.digitsEnToFa(discountObject.percent) +
            "<br />"
        html +=
            "<strong>قیمت با تخفیف:</strong> " +
            formattedPrices(discountObject.priceWithDiscount)
        return html
    }

    return { parseDiscountDetails, formattedPrices }
}
